import React, { useEffect, useState } from "react";
import { Link, useRouter } from "../../router";
import { api } from "../../api";
import AdminSubNav from "./AdminSubNav";

export default function AdminCoursesPage() {
  const [courses, setCourses] = useState(null);
  const [error, setError] = useState("");
  const [title, setTitle] = useState("");
  const [busy, setBusy] = useState(false);
  const { navigate } = useRouter();

  const load = () => api.get("/api/admin/courses").then((d) => setCourses(d.courses)).catch((e) => setError(e.message));

  useEffect(() => { load(); }, []);

  const createCourse = async (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    setBusy(true);
    try {
      const result = await api.post("/api/admin/courses", { title });
      navigate(`/admin/courses/${result.course.id}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const deleteCourse = async (course) => {
    if (
      !window.confirm(
        `Delete "${course.title}" permanently? This removes all its chapters, lessons, content, and student enrollment/progress records - this cannot be undone.`
      )
    )
      return;
    try {
      await api.del(`/api/admin/courses/${course.id}`);
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="page">
      <h1>Admin</h1>
      <AdminSubNav active="courses" />
      {error && <div className="alert alert-error">{error}</div>}

      <form onSubmit={createCourse} className="inline-form">
        <input
          placeholder="New course title, e.g. 'Advanced Negotiation'"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <button className="btn btn-primary" disabled={busy}>
          {busy ? "Creating…" : "Create course"}
        </button>
      </form>

      <table className="admin-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Status</th>
            <th>Price</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {courses &&
            courses.map((course) => (
              <tr key={course.id}>
                <td>{course.title}</td>
                <td>
                  <span className={`badge ${course.published ? "badge-success" : "badge-warning"}`}>
                    {course.published ? "Published" : "Draft"}
                  </span>
                </td>
                <td>{(course.price_cents / 100).toLocaleString("en-US", { style: "currency", currency: (course.currency || "usd").toUpperCase() })}</td>
                <td style={{ display: "flex", gap: 8 }}>
                  <Link to={`/admin/courses/${course.id}`} className="btn btn-secondary btn-sm">
                    Manage
                  </Link>
                  <button className="btn btn-ghost btn-sm" onClick={() => deleteCourse(course)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
